import type { ReactNode } from "react";
import { renderLinkifiedText } from "./waveLinkify";

export function renderTodoTitleInline(title: string): ReactNode[] {
  const parts: ReactNode[] = [];
  const regex = /(\*\*\*(.+?)\*\*\*|\*\*(.+?)\*\*|@([\p{L}\p{N}._-]+))/gu;
  let last = 0;
  let match: RegExpExecArray | null;
  let key = 0;
  while ((match = regex.exec(title)) !== null) {
    if (match.index > last) {
      parts.push(...renderLinkifiedText(title.slice(last, match.index)));
    }
    if (match[2]) {
      parts.push(
        <strong key={key++}>
          <em>{match[2]}</em>
        </strong>,
      );
    } else if (match[3]) {
      parts.push(<strong key={key++}>{match[3]}</strong>);
    } else if (match[4]) {
      parts.push(
        <span key={key++} className="wave-todo-mention-inline">
          @{match[4]}
        </span>,
      );
    }
    last = regex.lastIndex;
  }
  if (last < title.length) parts.push(...renderLinkifiedText(title.slice(last)));
  return parts.length ? parts : renderLinkifiedText(title);
}
